import { render, staticRenderFns } from "./CategoriesFilter.vue?vue&type=template&id=e59a005a&scoped=true"
import script from "./CategoriesFilter.vue?vue&type=script&lang=js"
export * from "./CategoriesFilter.vue?vue&type=script&lang=js"
import style0 from "./CategoriesFilter.vue?vue&type=style&index=0&id=e59a005a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59a005a",
  null
  
)

export default component.exports